export default "__VITE_ASSET__BXZjkW7K__";